// extracted by mini-css-extract-plugin
export var logo = "_5g-2";
export var logoWrapper = "_5g-1";
export var strip = "_5g-0";